<template>
  <div class="upProgress" :class="{ 'upProgress--dark': dark }">
    <img v-if="job && job.thumb" :src="job.thumb" class="upProgress__thumb" alt="" />
    <div class="upProgress__current">
      <v-progress-circular v-if="running" indeterminate size="14" width="2" class="mr-2" />
      <v-icon v-else-if="failed" small color="#ff8a80" class="mr-1">mdi-alert-circle-outline</v-icon>
      <span>{{ label }}</span>
    </div>
    <div v-if="steps.length" class="upProgress__steps">
      <div v-for="(s, i) in steps" :key="i" class="upProgress__step">
        <v-icon x-small class="mr-1">mdi-check</v-icon>{{ s.step }} <span class="upProgress__ms">{{ duration(s.ms) }}</span>
      </div>
    </div>
    <div v-if="error" class="upProgress__error">{{ error }}</div>
  </div>
</template>

<script>
import { formatDuration, isJobRunning, jobStatusLabel, subscribeUpscaleJob } from "@/upscaleJobs";

/** Ablauf eines Upscale-Jobs live (Import-Taskcard, solange der Task verarbeitet wird) */
export default {
  name: "UpscaleProgress",
  props: {
    jobId: { type: String, required: true },
    dark: { type: Boolean, default: false },
  },
  data() {
    return { job: null, error: "", unsubscribe: null };
  },
  computed: {
    running() {
      return !this.job || isJobRunning(this.job);
    },
    failed() {
      return !!this.job && this.job.status === "failed";
    },
    label() {
      if (!this.job) return "Upscale-Job wird geladen";
      return this.job.status === "done" ? "Upscale fertig" : jobStatusLabel(this.job);
    },
    steps() {
      return (this.job && Array.isArray(this.job.steps) ? this.job.steps : []).filter((s) => s && s.step);
    },
  },
  watch: {
    jobId: { immediate: true, handler: "subscribe" },
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    subscribe() {
      if (this.unsubscribe) this.unsubscribe();
      this.job = null;
      this.error = "";
      if (!this.jobId) return;
      this.unsubscribe = subscribeUpscaleJob(
        this.jobId,
        (job) => {
          this.job = job;
          this.error = job && job.status === "failed" ? job.error || "" : "";
        },
        (err) => {
          this.error = err.code === "permission-denied" ? "Kein Zugriff auf upscaleJobs (Firestore-Regel fehlt)" : err.message;
        }
      );
    },
    duration: formatDuration,
  },
};
</script>

<style lang="scss" scoped>
.upProgress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: rgba(0, 0, 0, 0.75);
  max-width: 280px;

  &--dark {
    color: #fff;
  }
  &__thumb {
    width: 84px;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  }
  &__current {
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 13.5px;
    text-align: center;
  }
  &__steps {
    display: flex;
    flex-direction: column;
    gap: 2px;
    opacity: 0.85;
  }
  &__step .v-icon {
    color: inherit !important;
  }
  &__ms {
    opacity: 0.7;
    margin-left: 4px;
  }
  &__error {
    font-size: 11.5px;
    color: #ff8a80;
    text-align: center;
  }
}
</style>
